module.exports = __webpack_public_path__ + "img/none2.2ffe35d3.png";